/* eslint-disable @typescript-eslint/no-floating-promises */

import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Languages } from 'lucide-react'
// import { useNavigate } from 'react-router-dom'

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from '@/components/ui/select'
import { cn } from '@/lib/utils'

// Define correctamente el tipo de las props que recibe el componente
interface LanguageSelectorProps {
  className?: string
  basic?: boolean
}

export const LanguageSelector: React.FC<LanguageSelectorProps> = ({ className, basic }) => {
  const { i18n } = useTranslation()
  const [language, setLanguage] = useState('zh_HK') // Inicialmente 'zh_HK'
  // const navigate = useNavigate()

  // Normaliza el idioma para manejar diferentes variantes como 'zh_HK'
  const normalizeLanguage = (lng: string): string => {
    if (lng.startsWith('zh')) {
      return 'zh_HK' // Normaliza cualquier variante de cantonés a 'zh_HK'
    }
    return lng
  }

  //console.log({ language })

  useEffect(() => {
    const storedLanguage = localStorage.getItem('language') ?? 'zh_HK'
    const currentLanguage = normalizeLanguage(storedLanguage)
    setLanguage(currentLanguage)
  }, [i18n.language])

  const changeLanguage = (value: string): void => {
    console.log({ value })
    const newLanguage = value === 'en_US' ? 'en_US' : 'zh_HK'
    i18n.changeLanguage(newLanguage)
    setLanguage(newLanguage)
    localStorage.setItem('language', newLanguage)
    // navigate(`/${newLanguage}`)
  }

  return (
    <>
      {
        basic === true
          ?
            <Select onValueChange={changeLanguage} value={language}>
              <SelectTrigger className={cn('w-auto text-primary', className, 'border-none', 'basic-select')}>
                <Languages className='mr-2' size={20} />
              </SelectTrigger>
              <SelectContent className='border-none'>
                <SelectItem value='en_US'>EN</SelectItem>
                <SelectItem value='zh_HK'>ZH</SelectItem>
              </SelectContent>
            </Select>
          : (
            <Select onValueChange={changeLanguage} value={language}>
              <SelectTrigger className={cn('w-[100px] text-primary', className)}>
                <Languages className='mr-2' size={20} />
                <SelectValue placeholder={language.toUpperCase()} />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value='en_US'>EN</SelectItem>
                <SelectItem value='zh_HK'>ZH</SelectItem>
              </SelectContent>
            </Select>
            )
      }
    </>
  )
}
